<template>
  <div v-if="editMode || dgRowInEditMode[gridId + '.' + rowKey]">
    <div class="profileImageWrapper">
      <span v-if="value">
        <img :src="value" class="rounded-circle m1" alt="Circle image" />
      </span>
      <span>
        <b-button
          v-if="!controlInfo.readonly"
          :id="`pick-profile-image-${widgetKey}-${rowKey}-${cellKey}`"
          variant="primary"
          size="sm"
        >Select an image</b-button>
        <b-button v-if="value && !controlInfo.readonly" variant="danger" size="sm" @click="remove">
          <icon name="remove" style="verticel-align: -3px;" />
        </b-button>
      </span>
    </div>
    <avatar-cropper
      @submit="crop"
      :trigger="`#pick-profile-image-${widgetKey}-${rowKey}-${cellKey}`"
      :labels="{ submit: 'Submit', cancel: 'Cancel' }"
      ref="cropper"
    />
  </div>
  <div v-else class="profileImageWrapper">
    <img v-if="value" :src="value" class="rounded-circle m1" alt="Circle image" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
// services
import db from '@/services/db'
// helpers
import eventBus from '@/helpers/event-bus'
// components
import AvatarCropper from 'vue-avatar-cropper'

export default {
  props: [
    'rowKey',
    'cellKey',
    'cellVal',
    'options',
    'gridId',
    'widgetKey',
    'display',
    'editMode',
    'isRequired',
    'controlInfo',
  ],
  components: {
    AvatarCropper,
  },
  data() {
    return {
      value: this.cellVal,
    }
  },
  computed: {
    ...mapState(['dgRowInEditMode']),
  },
  watch: {
    cellVal() {
      this.value = this.cellVal
    },
  },
  methods: {
    crop() {
      const cropper = this.$refs.cropper.cropper
      this.value = cropper.getCroppedCanvas().toDataURL()
      this.save()
    },
    remove() {
      this.value = null
      this.save()
    },
    save() {
      const data = {
        options: this.options,
        rowKey: this.rowKey,
        cellKey: this.cellKey,
        value: this.value || null,
      }

      if (
        this.options.isReactive ||
        typeof this.options.isReactive === 'undefined'
      ) {
        db.dataGrid.data.saveCellVal(data)
      } else {
        const rowInst = this.$instByClass(this, 'data-grid__row')

        rowInst.rowData[this.cellKey] = this.value
      }
    },
  },
  beforeDestroy() {
    this.value = null
  },
}
</script>

<style lang="scss" scoped>
.profileImageWrapper {
  display: flex;
  align-items: center;
  > span:first-child {
    margin-right: 15px;
  }
  img {
    width: 50px;
    height: 50px;
  }
}
</style>
